module.exports = "https://website-assets.prd.scentregroup.io/website/_next/static/media/find-out-more.07c27f43.png";